
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AutoBookingOverview extends Vue {
  @Prop({ required: true }) readonly icon!: string
  @Prop({ required: true }) readonly title!: string
}
